import { render, staticRenderFns } from "./ReportPurchase.vue?vue&type=template&id=72209af0&scoped=true"
import script from "./ReportPurchase.vue?vue&type=script&lang=js"
export * from "./ReportPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72209af0",
  null
  
)

export default component.exports